// AppLayout.tsx
import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import SideMenu from "./Components/Menus/SideMenu/SideMenu";
import { AuthContext, AuthContextType } from "./Types/AuthContext";

export default class AppLayout extends React.Component {
    static contextType = AuthContext;
    context!: AuthContextType;

    public render() {
        return (
            <div
                style={{
                    background: "linear-gradient(180deg, #FFFFFF 0%, #F7F9FC 100%)",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "stretch",
                    gap: "20px",
                    padding: "16px",
                    boxSizing: "border-box",
                    overflow: "hidden",
                }}
            >
                <SideMenu />
                <div
                    style={{
                        flex: 1,
                        minWidth: 0,
                        height: '100%',
                        backgroundColor: 'white',
                        borderRadius: '20px',
                        position: 'relative',
                        overflow: 'visible'
                    }}
                >
                    <Outlet/>
                </div>
            </div>
        );
    }
}
